import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData, SubmitButtonClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { useVerification } from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';

export interface Props {
  className?: string;
  hasCoreMembership?: boolean;
  openSubmitModal: () => void;
}

const MobileSubmitButton: React.FC<Props> = ({
  className,
  hasCoreMembership,
  openSubmitModal,
}) => {
  const { t } = useTranslation();
  const { isVerificationNeeded, pushVerificationPopup } = useVerification();
  const eclipse_submit = useFlag('eclipse_submit');
  const newSubmitEnabled = !hasCoreMembership || eclipse_submit;
  const onClick = isVerificationNeeded
    ? () => pushVerificationPopup('submit')
    : newSubmitEnabled
    ? openSubmitModal
    : undefined;

  return (
    <TextButton
      className={className}
      size="large"
      variant="main"
      href={
        !newSubmitEnabled && !isVerificationNeeded ? URLS.SUBMIT : undefined
      }
      onClick={onClick}
      icon={AddIcon}
      biData={BiData<SubmitButtonClickBiEvent>({
        evid: 704,
        sectionname: 'general',
      })}
    >
      {t('browse.submitButton.mobile')}
    </TextButton>
  );
};
MobileSubmitButton.displayName = 'MobileSubmitButton';

export default MobileSubmitButton;
